import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { SummaryHeader } from 'features/resources'
import { Button, TargetIcon, ResponsiveTable } from 'procyon-ui'
import useAppView from 'Core/Hooks/useAppView'
import { getHTMLDataTestID } from 'infra/utils'
import { columns, useADDomainControllers } from './ADDomainControllers.utils'
import { DeleteADDCModal } from './components/DeleteADDCModal'

const ADDomainControllers = () => {
  const history = useHistory()
  const location = useLocation()
  const { appView } = useAppView()
  const from = location.state?.from
  const [deleteTarget, setDeleteTarget] = useState(null)
  const { tableData } = useADDomainControllers({
    onEdit: (item) => navigateToEdit(item),
    onDelete: (item) => setDeleteTarget(item)
  })

  function navigateToEdit(item) {
    history.push({
      pathname: `/${appView}/addomainControllers/${encodeURIComponent(item.name)}`,
      state: { from }
    })
  }

  return (
    <div>
      {/* Header */}
      <div>
        <SummaryHeader
          rsrcName='RDP User Management'
          // Icon={(props) => <TargetIcon type='AD_DOMAIN_CONTROLER' {...props} />}
          actions={
            <Button
              data-testid={getHTMLDataTestID('ad-domain-controller', 'button', 'create')}
              size='md'
              style={{
                width: '200px'
              }}
              variant='primary'
              onClick={() =>
                history.push({
                  pathname: `/${appView}/addomainControllers/create`,
                  state: { from }
                })
              }
            >
              Create
            </Button>
          }
          breadCrumbsItems={
            from
              ? [
                  { label: 'Targets', link: `/${appView}/targets` },
                  { label: from.label, link: from.pathname },
                  { label: 'RDP User Management', link: null }
                ]
              : [{ label: 'RDP User Management', link: null }]
          }
        />
      </div>

      {/* Table */}
      <div className='p-4 bg-[var(--color-common-bg-base)] mt-8'>
        <div>
          <ResponsiveTable columns={columns} data={tableData} />
        </div>
      </div>

      {/* Delete Modal */}
      {deleteTarget && (
        <DeleteADDCModal
          addc={deleteTarget}
          onCancel={() => setDeleteTarget(null)}
          onSuccess={() => setDeleteTarget(null)}
        />
      )}
    </div>
  )
}

export { ADDomainControllers }
